import {
    Background,
    BackgroundColor,
    Container,
    Spacer,
    SpacerVariant,
    backgroundGreyScaleColorsOptions,
    spacerOptions,
} from "../layout"
import Typography, { TypographyElement } from "../../Typography"

import React from "react"
import { types } from "react-bricks/frontend"

interface SummaryProps {
    background: { color: BackgroundColor } | BackgroundColor
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
    summaryHeading?: TypographyElement[]
    summaryText?: TypographyElement[]
}

const Summary: types.Brick<SummaryProps> = ({ background, spacerTop, spacerBottom, variantTop, variantBottom }) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Container>
                <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
                <div className="mx-auto rounded-base bg-[linear-gradient(347deg,#fdb063_0%,#d07821_100%)] p-1 shadow-[0_0_6px_0_rgba(0,0,0,0.1)] sm:max-w-[600px] sm:rounded-lg sm:bg-[linear-gradient(328deg,#fdb063_0%,#d07821_100%)] sm:shadow-[0_0_10px_0_rgba(0,0,0,0.15)] lg:max-w-[900px] lg:bg-[linear-gradient(321deg,#fdb063_0%,#d07821_100%)] lg:p-[5px]">
                    <div className="rounded-sm bg-white p-7 sm:rounded-base sm:p-10 lg:p-16">
                        <div className="mb-5 lg:mb-7 font-gibson flex items-center">
                            <img className="mr-3 w-[22px] h-[22px] lg:w-7 lg:h-7" src="data:image/png;base64,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" alt=""/>
                            <Typography block="copytext-article" allowList={["bold"]} propName="summaryHeading" />
                        </div>
                        <Typography
                            block="copytext-article"
                            allowList={["bold", "italic", "link", "sup"]}
                            propName="summaryText"
                        />
                    </div>
                </div>
                <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
            </Container>
        </Background>
    )
}

Summary.schema = {
    name: "Summary",
    label: "Summary",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Summary.png`,
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                display: types.OptionsDisplay.Color,
                options: backgroundGreyScaleColorsOptions,
            },
        },
        {
            groupName: "Spacing",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Top Size",
                    type: types.SideEditPropType.Select,
                    show: props => !!props.spacerTop,
                    selectOptions: {
                        display: types.OptionsDisplay.Select,
                        options: spacerOptions,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Bottom Size",
                    type: types.SideEditPropType.Select,
                    show: props => !!props.spacerBottom,
                    selectOptions: {
                        display: types.OptionsDisplay.Select,
                        options: spacerOptions,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): SummaryProps => ({
        background: { color: BackgroundColor.White },
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
        summaryHeading: [
            {
                type: "h3",
                children: [
                    {
                        text: "Lorem ipsum:",
                        bold: true,
                    },
                ],
            },
        ],
        summaryText: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc placerat sagittis faucibus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc placerat sagittis faucibus.",
                    },
                ],
            },
        ],
    }),
}

export default Summary
